import {
  LOGIN,
  SUCCESS_LOGIN,
  ERROR_LOGIN,
  LOGOUT,
  SET_AUTH_DATA
} from '../../actions/auth';

export default function auth(state = {}, action) {
  switch (action.type) {
    case LOGIN:
      return Object.assign({}, state, action.payload);
    case SUCCESS_LOGIN:
      return Object.assign({}, state, action.payload);
    case ERROR_LOGIN:
      return Object.assign({}, state, action.payload);
    case LOGOUT:
      return Object.assign({}, state, action.payload);
    case SET_AUTH_DATA:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth/index.js